<fieldset>
	<legend>Error log</legend>
	<dx-data-grid id="gridContainer" [dataSource]="jobloginsight$ | async" keyExpr="id" [showBorders]="true" [wordWrapEnabled]="true">
		<dxo-summary>
			<dxi-group-item column="id" summaryType="min" [alignByColumn]="true">
			</dxi-group-item>
		</dxo-summary>
		<dxi-sort-by-group-summary-info summaryItem="id"></dxi-sort-by-group-summary-info>
		<dxi-column dataField="id" [visible]="false" [width]="100" [calculateCellValue]="calculateCellValue" [showInColumnChooser]="false" sortOrder="desc"></dxi-column>
		<dxi-column dataField="col_1_val" [width]="100" caption="Account number"></dxi-column>
		<dxi-column dataField="col_2_val" [width]="100" caption="Invoice number"></dxi-column>
		<dxi-column dataField="col_3_val" [width]="100" caption="Invoice ID"></dxi-column>
		<dxi-column dataField="col_4_val" caption="Message"></dxi-column>
		<dxi-column dataField="creationDate" sortOrder="desc" [visible]="false"></dxi-column>
		<dxi-column [width]="100" [allowFiltering]="false" [allowSorting]="false" cellTemplate="azureHistoryCellTemplate"></dxi-column>
		<div *dxTemplate="let data of 'azureHistoryCellTemplate'">
			<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="openAzureHistoryIfExists(data)">
    History
  </button>
		</div>


		<dxi-column dataField="sessionIdentifier" [(sortOrder)]="stateSortOrder" [groupIndex]="0" groupCellTemplate="groupTemplate" caption="Sort by date">
		</dxi-column>
		<div *dxTemplate="let obj of 'groupTemplate'">
			<ng-container *ngIf="obj.data && obj.data.collapsedItems && obj.data.collapsedItems[0]">
				<!-- {{obj.value}} -->
				<p style="margin:0px">{{padGroupingText(obj)}}</p>
			</ng-container>
			<ng-container *ngIf="obj.data && obj.data.items && obj.data.items[0]">
				<p style="margin:0px">{{padGroupingText(obj)}}</p>
			</ng-container>
		</div>

		<dxo-summary>
			<dxi-group-item column="id" summaryType="max" [alignByColumn]="true">
			</dxi-group-item>
		</dxo-summary>

		<dxo-selection [showCheckBoxesMode]="'none'"></dxo-selection>
		<dxo-search-panel [visible]="true"></dxo-search-panel>
		<dxo-paging [pageSize]="10"></dxo-paging>
		<dxo-group-panel [visible]="true"></dxo-group-panel>
		<dxo-grouping #expand [autoExpandAll]="false">
		</dxo-grouping>
	</dx-data-grid>
</fieldset>

<app-shell-pretty-json-viewer #picklistcomponent [json]="adminInstanceLog.value"></app-shell-pretty-json-viewer>

<fieldset>
	<legend>Traceparent ID searcher</legend>

	<dx-text-box [(value)]="traceparentid">
	</dx-text-box>
	<dx-button (onClick)="sendTraceparentid($event)" text="Retrieve traceparent exceptions"></dx-button>

	<dx-data-grid id="gridContainer" [dataSource]="traceparentInfo$ | async" [showBorders]="true" [width]="'100%'" (onCellClick)="onCellClick($event)">
		<dxo-paging [pageSize]="10"></dxo-paging>
		<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
		<dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
		<dxo-group-panel [visible]="true"></dxo-group-panel>
		<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	</dx-data-grid>
</fieldset>
